import { render, staticRenderFns } from "./Adept.vue?vue&type=template&id=5bab122b&scoped=true&"
import script from "./Adept.vue?vue&type=script&lang=js&"
export * from "./Adept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab122b",
  null
  
)

export default component.exports